export const LS_KEYS = {
    TOKEN: "token",
    TOKEN_EXPIRATION: "token_expiration_date",
    CODE_VERIFIER: "code_verifier",
    LOCATION: "location",
  };
  